import { FC, useEffect, useState } from 'react';
import { SweepViewReportProps } from './sweepReport.type';
import { Player } from '@inplay/models/dist/src/player';
import { POIClassification, SweepStatus } from '@inplay/models';
import { renderSweepTemplate } from '../../utils/renderSweepTemplate';

const SweepViewReport: FC<SweepViewReportProps> = (props) => {
  const [modalImage, setModalImage] = useState<string | null>(null);

  const formattedData = {
    ...props.pdfContentData,
    players:
      props.pdfContentData.players?.map((player: Player) => ({
        ...player,
        id: player.id.length > 5 ? player.id.substring(0, 5) : player.id,
        bodyImage: player.bodyImage ? player.bodyImage : '',
        gamblingHarm:
          player.poiClassification === POIClassification.POI ? 'Yes' : 'No',
      })) || [],
    time: props.pdfContentData.time,
  };

  const signatureHtml =
    props.pdfContentData.sweepStatus === SweepStatus.Missed
      ? renderSweepTemplate('missedSweep', formattedData)
      : renderSweepTemplate('signature', formattedData);
  const playerTableHtml = renderSweepTemplate(
    'playerTable',
    formattedData,
  );
  useEffect(() => {
    (window as any).__openModalHandler = (imageSrc: string) => {
      setModalImage(imageSrc);
    };

    props.onPlayerHtmlGenerated(playerTableHtml + signatureHtml);

    return () => {
      (window as any).__openModalHandler = undefined;
    };
  }, [playerTableHtml, signatureHtml]);

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: signatureHtml }} />
      <div dangerouslySetInnerHTML={{ __html: playerTableHtml }} />
      {modalImage && (
        <div
          id="imageModal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modalTitle"
          tabIndex={-1}
          style={{
            position: 'fixed',
            zIndex: 9999,
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={(e) => {
            if ((e.target as HTMLElement).id === 'imageModal') {
              setModalImage(null);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Escape') setModalImage(null);
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: 32,
              borderRadius: 16,
              width: '90%',
              maxWidth: 450,
              position: 'relative',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
              overflowY: 'auto',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 25,
              }}
            >
              <h2
                id="modalTitle"
                style={{
                  fontSize: 20,
                  fontWeight: 600,
                  margin: 0,
                }}
              >
                Player Image
              </h2>
              <span
                onClick={() => setModalImage(null)}
                style={{
                  fontSize: 28,
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  lineHeight: 1,
                }}
                aria-label="Close modal"
                role="button"
              >
                &times;
              </span>
            </div>

            {/* Image */}
            <img
              src={modalImage}
              alt="Player"
              draggable={false}
              style={{
                maxWidth: '100%',
                width: '100%',
                height: '40vh',
                objectFit: 'cover',
                borderRadius: 5,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SweepViewReport;
